import { useEffect } from 'react';

import { KingdomAndPlanResponse } from '../@types/KingdomResponse';
import { KdKanban } from '../@types/State';
import { useIntelState } from '../context/IntelState';
import RestUtilities from '../services/RestUtilities';

export const setOwnData = async (
  server: number,
  dispatch: React.Dispatch<any>
) => {
  dispatch({ type: 'SET_LOADING', payload: true });
  const response = await RestUtilities.get(
    `Kingdom/v1/OwnKingdom?server=${server}`
  );
  if (response.ok) {
    const responseContent: KingdomAndPlanResponse = response.content;
    const plan: KdKanban | undefined =
      responseContent.warPlan && JSON.parse(responseContent.warPlan);
    dispatch({ type: 'SET_OWN_DATA', payload: responseContent.kingdom });
    dispatch({ type: 'SET_OWN_PLAN', payload: plan });
    dispatch({
      type: 'SET_CURRENT_TICK',
      payload: responseContent.currentTick,
    });
  } else {
    dispatch({ type: 'SET_OWN_DATA', payload: undefined });
    dispatch({ type: 'SET_OWN_PLAN', payload: undefined });
  }
  dispatch({ type: 'SET_LOADING', payload: false });
};

export const setKdPlan = async (
  location: string | undefined,
  server: number,
  dispatch: React.Dispatch<any>
) => {
  if (location) {
    const response = await RestUtilities.get(
      `WarPlan/v1/Get?server=${server}&location=${location}`
    );
    if (response.ok) {
      const kdResponse: any = response.content;
      const newState: KdKanban = JSON.parse(kdResponse.json);
      dispatch({ type: 'SET_OWN_PLAN', payload: newState });
    } else {
      dispatch({ type: 'SET_OWN_PLAN', payload: undefined });
    }
  }
};

export const useOwnData = () => {
  const { intelState, intelDispatch } = useIntelState();
  useEffect(() => {
    if (
      intelState.ownData &&
      intelState.ownData?.server !== intelState.server
    ) {
      setOwnData(intelState.server, intelDispatch);
    }
  }, [intelState.ownData, intelState.server, intelDispatch]);
};
